module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": _vm.identifier,
      "width": "400",
      "height": "100"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0c70c12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/LineChart.vue
// module id = 3383
// module chunks = 0